import { Box, Tab, Tabs } from 'grommet'
import { useState } from 'react'
import { palette } from '../../../themes/'

type TabOption = {
  label: string
  value: string
  badge?: React.ReactNode
}

type Props = {
  options: Array<string | TabOption>
  setActive: (arg: string) => void
  divider?: boolean
  style?: React.CSSProperties
  tab?: string
}

const getOptionValue = (option: string | TabOption) => (typeof option === 'string' ? option : option.value)
const getOptionLabel = (option: string | TabOption) => (typeof option === 'string' ? option : option.label)
const getOptionBadge = (option: string | TabOption) => (typeof option === 'string' ? null : option.badge)

export const ActiveTab = ({ divider, options, setActive, style, tab }: Props) => {
  const [index, setIndex] = useState(
    tab ? options.findIndex(option => getOptionValue(option).toLowerCase() === tab.toLowerCase()) : 0
  )
  return (
    <Box
      border={divider && { color: '#c2c1c1d3', side: 'bottom', size: '1px' }}
      className="max-w-full overflow-x-auto"
      pad={divider ? { top: 'medium' } : { horizontal: '0' }}
    >
      <Tabs
        activeIndex={index}
        justify="start"
        onActive={setIndex}
        style={{ marginLeft: '10px', whiteSpace: 'nowrap' }}
      >
        {options?.map((option, i) => (
          <Tab
            className="tab"
            key={i}
            onClick={() => setActive(getOptionValue(option))}
            plain
            style={{
              borderBottom: `2px solid ${i === index ? palette.brand : 'transparent'}`,
              fontWeight: ` ${i === index ? '500' : ''}`,
              marginBottom: divider ? '-0.3px' : undefined,
              padding: 0,
              textTransform: 'capitalize',
              ...style
            }}
            title={
              <Box align="center" direction="row" gap="xsmall">
                <span>{getOptionLabel(option).replace(/_/g, ' ')}</span>
                {getOptionBadge(option)}
              </Box>
            }
          />
        ))}
      </Tabs>
    </Box>
  )
}
